import { chunk, endsWith, intersectionWith } from 'lodash-es'

import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    fetchAvailabilityBusyReport: build.query({
      async queryFn({
        uuids = [],
        organization,
        start,
        end,
        users = [],
        teams = [],
        groups = [],
        eventTypes = [],
        callback = () => {},
        limitPerRequest = 20,
        ...params // additional optional params such as groupBy, sort
      }, _queryApi, _extraOptions, fetchWithBQ) {
        const uuidClunks = chunk(uuids, limitPerRequest)
        const results = uuidClunks.reduce((acc, selectedUuids) => ({
          ...acc,
          [selectedUuids.join('')]: fetchWithBQ({
            url: '/api/reports/availability/busy',
            params: {
              organization,
              start,
              end,
              users: intersectionWith(users, selectedUuids, endsWith),
              teams: intersectionWith(teams, selectedUuids, endsWith),
              groups: intersectionWith(groups, selectedUuids, endsWith),
              eventTypes: intersectionWith(eventTypes, selectedUuids, endsWith),
              ...params
            }
          })
        }), {})

        const allProgress = (proms, callbackFn) => {
          for (const p of proms) {
            p.then(() => {
              callbackFn(proms)
            })
          }
          return Promise.all(proms)
        }

        const data = await allProgress(
          Object.values(results),
          callback
        ).then((values) => (values))
        const error = data.find((d) => d.error)

        return error ? { error } : { data }
      },
    }),
  })
})

export const {
  useFetchAvailabilityBusyReportQuery
} = api
